export default {
  filters: state => {
    return state.filters
  }
}
